module.exports = __webpack_public_path__ + "img/loan_summ_icon.97944aaa.svg";